export function capitalizeWords(s: string): string {
  return s.split(' ').map(capitalizeFirst).join(' ')
}

export function capitalizeFirst(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
}
